import * as React from "react";
import { useTreble } from 'treble-gsm';

function SvgLogoProtrans(props) {

  const [{ darkMode }] = useTreble();
  return (
    <svg
      id="logo-protrans_svg__Layer_1"
      data-name="Layer 1"
      viewBox="0 0 536.84 103.46"
      {...props}
    >
      <defs>
        <style>
          {
            `.logo-protrans_svg__cls-1{fill:${(darkMode) ? 'rgba(255,255,255,.7)' : '#101820'}}.logo-protrans_svg__cls-2{fill:${(darkMode) ? 'rgba(255,255,255,.7)' : '#990000'}}`
          }
        </style>
      </defs>
      <path
        className="logo-protrans_svg__cls-1"
        d="M214.64 120.19h-14l13-61.09h-21.47l2.55-12h56.9l-2.55 12h-21.44zM261.26 96l-5.13 24.17h-14l15.54-73.08H295c15.9.39 21 5.36 17.46 21.93-2.3 10.81-4.56 18.7-17.33 20.55L295 90c9.74.88 11 6.24 8.84 16.57L301 120.19h-14l2.91-13.64c1.3-6.14-.32-10.43-7-10.53zm21.07-12c10.32 0 13.29-2.05 15.57-12.76 2.2-10.33.74-12.18-9.29-12.18h-19.48L263.82 84z"
        transform="translate(-20.39 -44.1)"
      />
      <path
        className="logo-protrans_svg__cls-2"
        d="M367 57.87l-46.3 62.32h-14.51l52.59-73.08h20.66l1.82 73.08h-14.21z"
        transform="translate(-20.39 -44.1)"
      />
      <path
        className="logo-protrans_svg__cls-1"
        d="M456.6 47.11h14l-15.55 73.08h-23.24L413.73 59.1h-.49l-11.83 61.09h-14l15.54-73.08h23.19l18.26 61.09h.38zM483.7 96.9l-.73 3.41c-1.79 8.38 1.7 9 14.66 9 12.75 0 15-2.34 16.81-10.81 2.22-10.5-3.62-9.1-14.44-9.69-15.58-1-28.17-.39-23.66-21.63 4.27-20.07 17.06-20.65 34.6-20.65 14.91 0 27 .49 22.9 19.68l-.5 2.34h-14l.5-2.34c1.68-7.89-1.48-8.18-11.32-8.18-13.92 0-16.46 1.36-18.11 9.15-1.91 9-.13 9.26 13.92 10.14 22.21 1.36 28.1 2.53 24.15 21.14-4.38 20.54-14.48 22.31-33.3 22.31-16.17 0-30.7.49-26.25-20.46l.73-3.41z"
        transform="translate(-20.39 -44.1)"
      />
      <path
        className="logo-protrans_svg__cls-2"
        d="M338.51 41.15l.07 62.31h-46.33l46.26-62.31z"
      />
      <path
        className="logo-protrans_svg__cls-1"
        d="M549.22 44.1a8 8 0 11-8 8 8 8 0 018-8zm0 14.88a6.88 6.88 0 10-6.87-6.88 6.87 6.87 0 006.87 6.9zm-2.93-11.59h3.51c2.11 0 3.14.88 3.14 2.63a2.54 2.54 0 01-2.31 2.68l2.66 4.12h-1.4l-2.56-4.09h-1.92v4.09h-1.12zm1.12 4.21h1.75c1.32 0 2.66-.06 2.66-1.62 0-1.17-1.07-1.47-2.18-1.47h-2.23zM35.93 47.17h27.9c14.13 0 15.41 9.55 12.73 22.11-1.39 6.53-4.88 22.51-22.56 22.51H34.72l-6 28.45h-8.33zm6.73 7.3l-6.38 30h12.11c11 0 16.64.1 19.66-14.13 3-14 .85-15.88-9.38-15.88zM78.51 120.24h-8.29l15.55-73.07h24.39c15.78 0 21.77 4.38 18.23 21-2.18 10.23-5 17.83-16.87 19.29v.2c8.07.58 10.68 5.26 9 13.15l-4.13 19.39h-8.28l3.3-15.5C113.32 95.49 112 91 102 91H84.72zm24-36.54c12.85-.39 15.24-4.29 17.81-16.37 2-9.35 1.47-12.86-11.59-12.86H92.49L86.28 83.7zM164.94 46.22c18.17.19 22.44 6.23 18.54 24.55l-5.53 26c-3.67 17.24-11.27 23.67-28.81 23.67h-2.45c-17.53 0-22.4-6.43-18.73-23.67l5.53-26c3.9-18.32 10.73-24.36 29-24.55zm-4 7.31c-12.28 0-16.13 3-19.16 17.24l-5.53 26c-3.09 14.51 1.31 16.27 12 16.37h2.45c10.73-.1 15.88-1.86 19-16.37l5.53-26c3-14.22.46-17.24-11.82-17.24z"
        transform="translate(-20.39 -44.1)"
      />
    </svg>
  )
}

export default SvgLogoProtrans
